export const roundToDecimalPlace = (number, decimalPlaces) => {
	const factor = Math.pow(10, decimalPlaces);
	return Math.round(number * factor) / factor;
};

export const formatNumberWithCommas = number => {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
